module.exports = __webpack_public_path__ + "static/media/NYTimes.fe01a754.png";